export function getCurrentRefinementsWidget(containerId = '[data-widget="current-refinements"]') {
    return window.instantsearch.widgets.currentRefinements({
        container: containerId
    });
}
